/* Muse & Fur | Private Studio */
(function () {
  var root = document.getElementById('MuseStudio');
  if (!root) return;

  var KEY = 'mf-studio-v2';
  var doorForm = document.getElementById('StudioDoorForm');
  var briefForm = document.getElementById('StudioBriefForm');
  var studioEmail = root.getAttribute('data-email');
  var STUDIO = { pet: 0, direction: 1, space: 2, brief: 3 };
  var DARK = { door: true, sent: true };
  var state = load();

  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function greeting() {
    var h = new Date().getHours();
    return h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';
  }
  function makeRef() {
    var d = new Date();
    var mm = ('0' + (d.getMonth() + 1)).slice(-2);
    var dd = ('0' + d.getDate()).slice(-2);
    return mm + dd + '-' + Math.floor(100 + Math.random() * 900);
  }
  function values() {
    return {
      first: state.first || state.sentFirst,
      pet: state.pet || state.sentPet,
      ref: state.ref || state.sentRef,
      greeting: greeting()
    };
  }

  function show(step, focus) {
    var idx = STUDIO[step];
    var group = idx !== undefined ? 'studio' : step;

    $$('[data-screen]').forEach(function (s) { s.hidden = s.getAttribute('data-screen') !== step; });
    $('[data-studio]').hidden = idx === undefined;
    $$('[data-head]').forEach(function (el) { el.hidden = el.getAttribute('data-head') !== group; });
    root.setAttribute('data-tone', DARK[step] ? 'dark' : 'light');

    if (idx !== undefined) {
      $$('li', $('[data-progress]')).forEach(function (li, i) {
        li.classList.toggle('is-done', i < idx);
        li.classList.toggle('is-current', i === idx);
      });
    }

    clearErrors();
    if (step !== 'sent') { state.step = step; save(); }
    render();

    if (focus) {
      window.scrollTo(0, 0);
      var h = $('[data-screen="' + step + '"] h1, [data-screen="' + step + '"] h2');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    }
  }

  function render() {
    var v = values();
    $$('[data-input]').forEach(function (el) {
      if (document.activeElement !== el) el.value = state[el.getAttribute('data-input')] || '';
    });
    $$('[data-field]').forEach(function (b) {
      b.setAttribute('aria-pressed', state[b.getAttribute('data-field')] === b.getAttribute('data-value') ? 'true' : 'false');
    });
    $$('[data-v]').forEach(function (el) {
      el.textContent = v[el.getAttribute('data-v')] || el.getAttribute('data-default') || '';
    });
    $$('[data-show]').forEach(function (el) { el.textContent = state[el.getAttribute('data-show')] || '-'; });

    var box = $('[data-brief-img]');
    var chosen = $('[data-field="direction"][aria-pressed="true"]');
    var src = chosen ? chosen.getAttribute('data-img') : '';
    box.innerHTML = '';
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      box.appendChild(img);
    }
    box.hidden = !src;
  }

  function clearErrors() { $$('[data-error]').forEach(function (e) { e.textContent = ''; }); }
  function fail(step, msg) {
    var e = $('[data-screen="' + step + '"] [data-error]');
    if (e) e.textContent = msg;
    return false;
  }

  function validate(step) {
    if (step === 'door') {
      if (!state.first) return fail(step, 'Please add your first name.');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email || '')) return fail(step, 'Please add a valid email address.');
    }
    if (step === 'welcome') {
      if (!state.pet) return fail(step, "Please add your companion's name.");
      if (!state.purpose) return fail(step, 'Please choose who the portrait is for.');
    }
    if (step === 'pet' && !state.type) return fail(step, 'Please choose one.');
    if (step === 'direction' && !state.direction) return fail(step, 'Choose a direction, or let us advise.');
    if (step === 'space') {
      if (!state.placement) return fail(step, 'Please choose a room.');
      if (!state.size) return fail(step, 'Please choose a size, or let us help you choose.');
      if (!state.frame) return fail(step, 'Please choose a frame, or let us help you choose.');
    }
    return true;
  }

  /* Sending to the studio inbox.
     Request Entry and Send My Portrait Brief are the submit buttons of real Shopify contact forms,
     so Shopify's spam protection works exactly as on the Contact page. Before each form submits,
     the script adds the details as hidden fields. Shopify returns the visitor to this page, and
     the starting logic below picks up where they left off. */
  function fill(target, data) {
    $$('[data-dyn]', target).forEach(function (n) { n.parentNode.removeChild(n); });
    Object.keys(data).forEach(function (k) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'contact[' + k + ']';
      i.value = data[k] || '';
      i.setAttribute('data-dyn', '');
      target.appendChild(i);
    });
  }
  function leadData() {
    return {
      'Stage': 'Requested entry',
      'Reference': state.ref,
      body: state.first + ' requested entry to the studio. Their brief will follow if they finish.'
    };
  }
  function briefData() {
    return {
      name: state.first,
      email: state.email,
      'Stage': 'Brief complete',
      'Reference': state.ref,
      'Companion': state.pet,
      'Pet': [state.type, state.breed].filter(Boolean).join(', '),
      'For': state.purpose,
      'Direction': state.direction,
      'Size': state.size,
      'Frame': state.frame,
      'Room': state.placement,
      body: state.notes || 'No notes added.'
    };
  }

  function cleanUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      window.history.replaceState(null, '', url.pathname + url.search);
    } catch (e) {}
  }

  function finish() {
    state = { sentFirst: state.first, sentPet: state.pet, sentRef: state.ref };
    save();
    var pet = state.sentPet || 'my companion';
    var subject = 'Photographs for ' + pet + (state.sentRef ? ' (Ref ' + state.sentRef + ')' : '');
    var body = 'Hello Muse & Fur,\n\nHere are a few photographs of ' + pet + '.\n\n' + (state.sentFirst || '');
    $('[data-mailto]').href = 'mailto:' + studioEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    show('sent', true);
  }

  /* Events */
  root.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-field]');
    if (opt) {
      state[opt.getAttribute('data-field')] = opt.getAttribute('data-value');
      save();
      render();
      clearErrors();
      return;
    }
    var go = e.target.closest('[data-go]');
    if (go) { show(go.getAttribute('data-go'), true); return; }

    var next = e.target.closest('[data-next]');
    if (next) {
      var current = next.closest('[data-screen]').getAttribute('data-screen');
      if (validate(current)) show(next.getAttribute('data-next'), true);
    }
  });

  root.addEventListener('input', function (e) {
    var k = e.target.getAttribute('data-input');
    if (!k) return;
    state[k] = e.target.value.trim();
    save();
  });

  root.addEventListener('submit', function (e) {
    var f = e.target;
    $$('[data-input]', f).forEach(function (el) { state[el.getAttribute('data-input')] = el.value.trim(); });

    /* The door: a real Shopify form. Let it submit unless something is missing. */
    if (f === doorForm) {
      if (!validate('door')) { e.preventDefault(); return; }
      if (!state.ref) state.ref = makeRef();
      var leadKey = (state.email || '').toLowerCase();
      if (state.leadSent === leadKey && !doorForm.mfRetry) {
        /* Already introduced in this visit: no second email. */
        e.preventDefault();
        save();
        show('welcome', true);
        return;
      }
      state.leadSent = leadKey;
      state.pending = 'lead';
      save();
      fill(doorForm, leadData());
      doorForm.mfOk = true;
      return;
    }

    /* The brief: a real Shopify form. */
    if (f === briefForm) {
      if (!state.first || !state.email) { e.preventDefault(); show('door', true); validate('door'); return; }
      state.pending = 'brief';
      save();
      fill(briefForm, briefData());
      briefForm.mfOk = true;
      return;
    }

    /* The welcome screen: moves on without sending. */
    if (f.getAttribute('data-form') === 'welcome') {
      e.preventDefault();
      if (validate('welcome')) show('pet', true);
    }
  });

  /* Shopify's spam check can hold back the first click while it fetches its token.
     If the page has not started to leave shortly after, click once more on the visitor's behalf. */
  var leaving = false;
  window.addEventListener('beforeunload', function () { leaving = true; });
  root.addEventListener('submit', function (e) {
    var f = e.target;
    if ((f !== doorForm && f !== briefForm) || !f.mfOk) return;
    f.mfOk = false;
    var btn = f.querySelector('button[type="submit"]');
    if (btn) btn.textContent = f === doorForm ? 'Opening the studio' : 'Sending';
    if (f.mfRetry) return;
    setTimeout(function () {
      if (leaving || f.mfRetry) return;
      f.mfRetry = true;
      if (window.console) console.info('[Muse Studio] sending again after the spam check');
      if (btn) btn.click();
    }, 1500);
  });

  if (doorForm) doorForm.noValidate = true;

  /* Starting point */
  var posted = !!$('[data-posted]') || window.location.search.indexOf('contact_posted=true') > -1;
  var pending = state.pending;
  if (pending) {
    state.pending = false;
    save();
    cleanUrl();
  }
  if (pending === 'lead') {
    /* Carry on even if the first note did not go through: the brief repeats everything. */
    show('welcome', true);
  } else if (pending === 'brief' && posted) {
    finish();
  } else if (pending === 'brief') {
    show('brief', true);
    fail('brief', 'We could not confirm your brief was sent. Please try once more, or write to ' + studioEmail + '.');
  } else if (state.first && state.email && state.step && state.step !== 'door') {
    show(state.step, false);
  } else {
    show('door', false);
  }
})();
